import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const LABEL: BlockOverrides = {
  Block: {
    style: {
      maxHeight: '48px',
      fontSize: '12px',
      marginTop: '2px',
      color: THEME.colors.mono600,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
    },
  },
};
